import { getRecruitmentCampaigns as getRecruitmentCampaignsApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  GetRecruitmentCampaignsServiceRequest,
  GetRecruitmentCampaignsServiceResponse,
} from './get-recruitment-campaigns.dto';
import {
  GetRecruitmentCampaignsServiceRequestSchema,
  GetRecruitmentCampaignsServiceResponseSchema,
} from './get-recruitment-campaigns.dto';

const DEFAULT_SIZE = 10;

export const getRecruitmentCampaignsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetRecruitmentCampaignsServiceRequestSchema),
    async (
      request: GetRecruitmentCampaignsServiceRequest,
    ): Promise<GetRecruitmentCampaignsServiceResponse> => {
      const apiResponse = await getRecruitmentCampaignsApi(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '모집형 캠페인 목록 조회에 실패했습니다.');
      }

      const page = request.page ?? 1;
      const size = request.size ?? DEFAULT_SIZE;
      // BE 표준 wrapper 의 link.next 가 다음 페이지 유무를 알려줌
      // (getCoupons/getProposalGoods/getCurations 등 도메인 표준 패턴)
      const hasNext = apiResponse.link?.next != null;

      return {
        list: apiResponse.data.list,
        pagination: {
          page,
          size,
          hasNext,
          nextPage: hasNext ? page + 1 : null,
        },
      };
    },
    validateServiceResponse(GetRecruitmentCampaignsServiceResponseSchema),
  ),
);
